export default "__VITE_ASSET__Cc81eVpN__"